"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = __importDefault(require("lodash"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ExpandedItem = function (_a) {
    var label = _a.label, data = _a.data, icon = _a.icon;
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.useState(false), expanded = _b[0], setExpanded = _b[1];
    var getTranslated = function (title, index) {
        return react_1.default.createElement("p", { key: index }, t('FIELD_OPTIONS' + '.' + title, title));
    };
    if (lodash_1.default.isUndefined(data)) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", { className: classnames_1.default('amenity-item', styles_module_scss_1.default.amenity_item) },
        icon && label && (react_1.default.createElement("div", { className: "push-left" },
            react_1.default.createElement("i", { className: "icon-ic-" + icon }),
            react_1.default.createElement("span", { className: "title" }, t('fields.section6.' + label)))),
        react_1.default.createElement("div", { className: "amenity-info", onClick: function () { return setExpanded(!expanded); } },
            react_1.default.createElement("p", null,
                t('FIELD_OPTIONS.' + data[0]),
                !expanded && data.length > 1 && (react_1.default.createElement("span", { className: "counter" },
                    ' ',
                    "\u00A0+",
                    data.length - 1,
                    ' '))),
            expanded && data.length > 1 && (react_1.default.createElement("div", { className: styles_module_scss_1.default.option_list }, data
                .slice(1)
                .map(function (a, index) { return getTranslated(a, index); }))))));
};
exports.default = ExpandedItem;
